app.controller('popupAllergyUpdateController', ['$scope', '$state', '$mdDialog', 'objectHelper', 'baseModel', 'applicationModel', 'visitModel', 'userModel', 'patientModel', 'allergyModel', 'allergyToUpdate', 'preview',
    function ($scope, $state, $mdDialog, objectHelper, baseModel, applicationModel, visitModel, userModel, patientModel, allergyModel, allergyToUpdate, preview) {

        function setData() {
            $scope.allergy = angular.copy(allergyToUpdate);
            $scope.allergy.patient = new PatientVO();
            $scope.allergy.patient.id = $state.params.patientId;

            $scope.forms = {
                allergyForm: null
            };

            $scope.allergyActionType = 'update';
            $scope.requireAllergyNote = false;

            Enum.ALLERGY_TYPE_UPDATE = {
                OTHER: 'OTHER',
                FOOD: 'FOOD',
                DRUGS: 'DRUGS',
                POLLEN: 'POLLEN'
            };

            Object.freeze(Enum.ALLERGY_TYPE_UPDATE); //fixme probably need to re-think for better solution

            $scope.actionInProgress = false;

            $scope.previewOnly = preview || ($scope.allergy.author.userType === 'DOCTOR' && $scope.allergy.author.id != userModel.currentUser.id);
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$watch('allergy.type', function(newVal) {
                $scope.requireAllergyNote = newVal != Enum.ALLERGY_TYPE.PATIENT_CLAIMS_NO_ALLERGIES;
            })
        }

        function setActions() {
            $scope.allergyAction = function () {

                $scope.forms.allergyForm.$setSubmitted();
                if ($scope.forms.allergyForm.$valid) {
                    $scope.actionInProgress = true;
                    allergyModel.update($scope.allergy);

                    var successWatcherDisabler = $scope.$on(Event.ALLERGY.UPDATE.SUCCESS, function (event, result) {
                        successWatcherDisabler();
                        errorWatcherDisabler();
                        $scope.actionInProgress = false;
                        $mdDialog.hide();
                    });
                    var errorWatcherDisabler = $scope.$on(Event.ALLERGY.UPDATE.ERROR, function (event, error) {
                        successWatcherDisabler();
                        errorWatcherDisabler();
                        $scope.actionInProgress = false;
                    });
                }
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            }
        }

        function configureInterface() {

        }

        function initialize() {
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);